import { h, mount } from '../lib/dom';

/**
 * Menu items. Edit this list — the nav re-renders from it.
 *
 * Adding a section: append `{ label, href }` and create the matching page.
 */
export interface NavItem {
  label: string;
  href: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Items', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Docs', href: '/docs' },
];

export function renderNav(target: HTMLElement, currentPath = window.location.pathname) {
  const node = h(
    'div',
    { class: 'nav-inner' },
    ...NAV_ITEMS.map((item) =>
      h(
        'a',
        {
          href: item.href,
          'aria-current': item.href === currentPath ? 'page' : null,
        },
        item.label,
      ),
    ),
  );
  mount(target, node);
}
